module.exports = __webpack_public_path__ + "img/xj3.a190cf07.png";